import { matchesNew } from '@components/bid_request/details/utils/matchesNew';
import { countDeletedSavedRows } from '@features/buyer-line-items-pagination/utils/count-deleted-saved-rows';
import type { Lot, LotChanges } from 'types';

export const shouldMountLotTable = ({ lot, lotChanges }: { lot: Lot; lotChanges?: LotChanges }): boolean => {
  const hasNewRow = Object.keys(lotChanges?.line_items ?? {}).some(matchesNew);

  return hasNewRow || (lot.line_items_count ?? 0) - countDeletedSavedRows(lotChanges) > 0;
};
